export default __webpack_public_path__ + "static/media/back-arrow_blue.de31ddb9.svg";